import React, { useEffect, useState } from 'react';
import { Row, Col, Typography, Input, Button, Space, message, Form } from 'antd';
import { CopyOutlined, EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { AddUpdateWhatsapp, getOmni } from '../../redux/OmniChannels/OmniChannelsActions';

const { Title, Text } = Typography;

const MassengerConfigration = () => {
    const [form] = Form.useForm();
    const [secretTokenVisible, setSecretTokenVisible] = useState(false);
    const [secretTokenVisiblee, setSecretTokenVisiblee] = useState(false);
    const userData = useSelector((state) => state.Auth.userData);
    const usertoken = useSelector((state) => state.Auth.token);
    const { data, loading_state, omniData } = useSelector((state) => state.OmniChannelsReducer);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getOmni({ companyId: userData?.companyId }));
    }, []);

    const webhookUrl = 'https://apigateway.convobird.com/agents/whatsapp';

    const handleCopy = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            message.success('Copied!');
        } catch {
            message.error('Failed to copy!');
        }
    };

    const handleSubmit = (values) => {
        let newData = {
            ...values,
            companyId: userData?.companyId
        }
        dispatch(AddUpdateWhatsapp(newData, usertoken))
    };

    useEffect(() => {
        if (omniData) {
            form.setFieldsValue({
                access_token: omniData.access_token,
                phone_number_id: omniData.phone_number_id,
            });
        }
    }, [omniData, form]);

    return (
        <div style={{ padding: 24, background: '#fff', borderRadius: 12 }}>
            <Row gutter={32}>
                {/* LEFT SIDE */}
                <Col xs={24} md={12}>
                    <Title level={4}>Massenger Configuration</Title>

                </Col>

                {/* RIGHT SIDE */}
                <Col xs={24} md={12}>
                    <Title level={4}>Configuration Info</Title>

                </Col>
            </Row>
        </div >
    );
};

export default MassengerConfigration;
